var map = {
	"./Cores.mp4": 1499,
	"./Criar,editar e excluir.mp4": 5722,
	"./Download PDF.mp4": 7901,
	"./Fontes.mp4": 9592,
	"./alinhamento.mp4": 5785,
	"./tamanho.mp4": 4907,
	"./titulo.mp4": 7396,
	"./wallpaper.mp4": 2229,
	"layout/Main/Explanation/videos/Cores.mp4": 1499,
	"layout/Main/Explanation/videos/Criar,editar e excluir.mp4": 5722,
	"layout/Main/Explanation/videos/Download PDF.mp4": 7901,
	"layout/Main/Explanation/videos/Fontes.mp4": 9592,
	"layout/Main/Explanation/videos/alinhamento.mp4": 5785,
	"layout/Main/Explanation/videos/tamanho.mp4": 4907,
	"layout/Main/Explanation/videos/titulo.mp4": 7396,
	"layout/Main/Explanation/videos/wallpaper.mp4": 2229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 947;